module.exports = __webpack_public_path__ + "static/media/space_video.c7f6a7d7.793bbc64.mp4";